import { getFormFullUrl } from "@Components/LeadForm/utils";
import getParsedLocalStorageData from "@Components/LeadFormModal/helpers/getParsedLocalStorageData";
import getSelectedRoomAndTenancy from "./getSelectedRoomAndTenancy";

const getBookFormLink = ({
  rooms = [],
  bookFormInitiated = {},
  canonicalName,
  id,
}: {
  rooms?: any;
  bookFormInitiated?: any;
  canonicalName: any;
  id?: number;
}) => {
  const lfOneSuccessData: any = getParsedLocalStorageData("lead-form-one-success-data");
  const options: any = {};

  if (rooms.length > 0 && id) {
    const { selectedRoom, selectedTenancy } = getSelectedRoomAndTenancy({ rooms, id });

    if (selectedTenancy) {
      options.inventory_id = selectedTenancy.meta?.available_from_formatted
        ? selectedTenancy.id
        : `${selectedRoom?.id}${selectedTenancy.id}`;
      options.lease_duration = `${selectedTenancy.meta.lease_duration} ${selectedTenancy.meta.lease_duration_unit}`;
    } else {
      // todo - if lead is filled against room (where it does not have any tenancies), it will always
      // a flexible
      // options.inventory_id = 'flexible;
      options.inventory_id = selectedRoom?.id;
      options.lease_duration = "flexible";
    }

    options.config_name = selectedRoom?.name;
    options.bookform_source = "enquire_property";
  } else {
    const {
      id: currId,
      config_name,
      custom_duration,
      arrival_date,
      config_id,
      level,
      meta,
    } = bookFormInitiated;

    if (level === "tenancy") {
      options.inventory_id = meta?.available_from_formatted ? currId : `${config_id}${currId}`;
      options.lease_duration = `${meta?.lease_duration} ${meta?.lease_duration_unit}`;
      if (arrival_date) options.arrival_date = arrival_date;
    } else {
      options.inventory_id = currId;
      options.lease_duration = "flexible";
      if (custom_duration) options.custom_duration = custom_duration;
      if (arrival_date) options.arrival_date = arrival_date;
    }
    options.config_name = config_name;
  }

  if (Object.keys(lfOneSuccessData).length) {
    options.lead_id = lfOneSuccessData.id;
    if (lfOneSuccessData.uuid) options.lead_uuid = lfOneSuccessData.uuid;
    if (lfOneSuccessData.data?.university) options.university = lfOneSuccessData.data.university;
    options.email = lfOneSuccessData.user_details.email;
  }
  return getFormFullUrl(canonicalName, options);
};

export default getBookFormLink;
